import { Pipe, PipeTransform } from "@angular/core";
import currency from "currency.js";
import Options = currency.Options;

/*
 * uses currency.js as an engine
 */
@Pipe({ name: "currencyRound" })
export class CurrencyRoundPipe implements PipeTransform {
  transform(
    param: any,
    options: Options = {
      separator: " ",
      decimal: ".",
      precision: 0,
    },
  ): number {
    return currency(param, options).value;
  }
}
